import { useState } from "react"
import type { Client } from "shared/src/DatabaseObjects/DatabaseObjects"
import { clientApi } from "shared/src/libs/apiLib/apiLib"
import { useLoadContext } from "shared/src/libs/contextLib/contextLib"
import { useMountEffect } from "shared/src/libs/hooksLib/hooksLib"
import { getCurrentYearMonth } from "shared/src/libs/dateLib/dateLib"
import { Card, CardContent } from "shared/src/components/shadcn/components/ui/card"
import { Spinner } from "shared/src/components/shadcn/components/ui/spinner"

interface VolumeCardProps {
	readonly number: number
	readonly label: string
	readonly fetching?: boolean
}

function VolumeCard({ number, label, fetching = false }: VolumeCardProps) {
	return (
		<Card className="min-w-[180px] w-fit">
			<CardContent className="py-6">
				<div className="flex flex-col items-center justify-center gap-2">
					<div className="text-4xl font-normal text-foreground">
						{fetching ? <Spinner className="size-8" /> : number}
					</div>
					<div className="text-sm text-muted-foreground">{label}</div>
				</div>
			</CardContent>
		</Card>
	)
}

export function VolumeTab() {
	const { company } = useLoadContext()
	const [stats, setStats] = useState<Client["stats"]>({} as Client["stats"])
	const [year, month] = getCurrentYearMonth()

	useMountEffect(() => {
		//set stats using current company details,then make API call to update
		setStats(company.stats)
		clientApi.get({ clientId: company.id }).then((response) => {
			setStats((response as Client).stats)
		})
	})

	return (
		<div>
			{/* This month section */}
			<Card>
				<CardContent className="sm:gap-12 flex-col sm:flex-row flex">
					<div className="py-6">
						<h3 className="text-sm font-medium text-foreground mb-4">This month</h3>
						<div className="flex gap-4">
							<VolumeCard number={stats?.all?.[year]?.[month]?.cvs_read ?? 0} label="CVs read" />
						</div>
					</div>

					{/* This year section */}

					<div className="py-6">
						<h3 className="text-sm font-medium text-foreground mb-4">This year</h3>
						<div className="flex gap-4">
							<VolumeCard
								number={Object.values(stats?.all?.[year] ?? {}).reduce((a, b) => a + (b?.cvs_read ?? 0), 0)}
								label="CVs read"
							/>
						</div>
					</div>
				</CardContent>
			</Card>
		</div>
	)
}
